export const environment = {
    envName: 'dev',
    api: {
        protocol: undefined,
        hostname: 'www.api.dev.boxhub.df-tech.cz',
        port: '443',
    },
};